import {Suspense} from 'react';
import ErrorBoundary from 'react-error-boundary';
import ErrorFallback from 'ErrorFallback';
import {BrowserRouter, Route} from 'react-router-dom';
import {QueryParamProvider} from 'use-query-params';
import {Authenticated, useUser, withAuthorization} from '@postinumero/authorization';
import CssBaseline from '@material-ui/core/CssBaseline';
import Pages from './Pages';
import Spinner from './Spinner';
import theme from 'theme';
import {ThemeProvider} from '@material-ui/core/styles';
import {useDetectLoginChange} from 'login';
import {useKeycloak} from '@react-keycloak/web';

import axios from 'axios';
import Keycloak from 'Keycloak';
import SnackBarProvider from 'shared/SnackBar/SnackbarContext';
import AppBar from "./AppBar";
import NavItems from "./AppBar/Navigation/NavItems";
import MiniVariantDrawer from "../shared/MiniVariantDrawer";
import {useTranslation} from 'react-i18next';
import SelectRoleDialog from "./SelectRoleDialog";
import {getConfig} from "../config";
import NoRoles from "./Pages/NoRoles";
import Landing from "./Pages/Landing";

const Layout = ({children}) => {
  const [t] = useTranslation();
  const {keycloak} = useKeycloak();

  const roles = keycloak?.tokenParsed?.resource_access[getConfig("KEYCLOAK_CLIENT_ID")]?.roles ?? [];

  return (
    <MiniVariantDrawer drawerOpenAriaLabel={t('drawer.open')}>
      <MiniVariantDrawer.AppBar>
        <AppBar/>
      </MiniVariantDrawer.AppBar>
      <MiniVariantDrawer.Drawer>
        <NavItems/>
      </MiniVariantDrawer.Drawer>
      <MiniVariantDrawer.Content>
        <Suspense fallback={<Spinner/>}>
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <Authenticated fallback={<Landing/>}>
              {Array.isArray(roles) && roles.length > 0 ?
                (
                  <>
                    <SelectRoleDialog/>
                    {children}
                  </>
                ) : (
                  <NoRoles/>
                )
              }
            </Authenticated>
          </ErrorBoundary>
        </Suspense>
      </MiniVariantDrawer.Content>
    </MiniVariantDrawer>
  );
}


function App() {
  useDetectLoginChange();

  const user = useUser();
  axios.defaults.headers.common['User-Role'] = user?.roles ? user.roles[0] : null;

  return (
    <Keycloak>
      <ThemeProvider theme={theme}>
        <CssBaseline/>
        <BrowserRouter>
          <QueryParamProvider ReactRouterRoute={Route}>
            <ErrorBoundary FallbackComponent={ErrorFallback}>
              <Suspense fallback={<Spinner/>}>
                <SnackBarProvider>
                  <Layout user={user}>
                    <Pages/>
                  </Layout>
                </SnackBarProvider>
              </Suspense>
            </ErrorBoundary>
          </QueryParamProvider>
        </BrowserRouter>
      </ThemeProvider>
    </Keycloak>
  );
}

export default withAuthorization(App);
